/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import {LocalForm} from 'react-redux-form';
import {submitTOTPSetupChallenge} from '../../actions/actions';
import QRCodeContainer from '../formFields/QRCodeContainer';
import PropTypes from 'prop-types';

class ScanCodeForm extends React.Component {

    handleSubmit() {
        const { dispatch, challenge, token} = this.props;
        dispatch(submitTOTPSetupChallenge(token, challenge));
    }

    constructor(props) {
        super(props);
        this.state = {showHint: false};
        this.showHint = this.showHint.bind(this);
        this.showQRCode = this.showQRCode.bind(this);
    }

    showHint() {
        this.setState({ showHint: true });
    };

    showQRCode() {
        this.setState({ showHint: false });
    };

    render() {
        const {title, scanCodeSubtitle, enterKeyTitle, submitLabel, QRValue, showQRCodeLabel, hintLabel, hintValue} = this.props;

        let currentTitle = title;
        let display = (<QRCodeContainer value={QRValue} />);
        let link = (<div onClick={this.showHint} className="op-link">{hintLabel}</div>);
        if (this.state.showHint) {
            currentTitle = enterKeyTitle;
            display = (<div className="message-container"> {hintValue} </div>);
            link = (<div onClick={this.showQRCode} className="op-link">{showQRCodeLabel}</div>);
        }

        return (
            <div>
                <LocalForm model="loginForm" className="login-form" onSubmit={() => this.handleSubmit()}>
                    <h4 className="has-subtitle">{currentTitle}</h4>
                    <span className="subtitle">{scanCodeSubtitle}</span>
                    {display}
                    {link}
                    <button className="wdc-btn wdc-btn-primary form-field-button-width">{submitLabel}</button>
                </LocalForm>
            </div>
        );
    }
}

ScanCodeForm.propTypes = {
    title: PropTypes.string,
    scanCodeSubtitle: PropTypes.string,
    enterKeyTitle: PropTypes.string,
    submitLabel: PropTypes.string,
    usernameError: PropTypes.string,
    QRValue: PropTypes.string,
    showQRCodeLabel: PropTypes.string,
    challenge: PropTypes.string,
    token: PropTypes.string,
    hintLabel: PropTypes.string,
    hintValue: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        username: state.login.username,
        passwordError: state.login.errorText,
        token: state.login.token,
        title: state.login.challengeResponse.title,
        QRLabel: state.login.challengeResponse.prompts.totpSecret.label,
        QRValue: state.login.challengeResponse.prompts.totpSecret.value,
        hintLabel: state.login.challengeResponse.prompts.manualTotpSecret.label,
        hintValue: state.login.challengeResponse.prompts.manualTotpSecret.value,
        showQRCodeLabel: state.login.challengeResponse.prompts.showQrCode.label,
        scanCodeSubtitle: state.login.challengeResponse.prompts.scanCodeSubtitle.label,
        enterKeyTitle: state.login.challengeResponse.prompts.enterKeyTitle.label,
        submitLabel: state.login.challengeResponse.submitLabel,
        challenge: state.login.challengeResponse.nextChallenge
    };
};

export default connect(mapStateToProps)(ScanCodeForm);
